module.exports = ".ck-emoji__actions .ck-button{font-size:20px;padding:.3em .5em 0;border:0}"